export const getCookies = (cname) => {
	if (typeof document !== 'undefined') {
		const decodedCookie = decodeURIComponent(document.cookie)
		const cookies = decodedCookie.split(';')

		for (let i = 0; i < cookies.length; i++) {
			let splitCookies = cookies[i].split('=')
			let cookieName = splitCookies[0].trim()
			let cookieValue = splitCookies[1]

			if (cookieName === cname) {
				return cookieValue
			}
		}
	}

	return null
}
